<div class="main-page consultas">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-12 my-2">
                <h1>
                    <a class="btn btn-voltar text-center mr-2" (click)="this.router.navigate(['/consultations'])"
                        data-title="Voltar"><i class="fas fa-arrow-left"></i></a>
                    Consulta de Tipo de Pârametros
                </h1>
            </div>
        </div>
        <div *ngIf="parametersModelPage?.page.totalElements === 0">
            <div class="row no-gutters mt-3">
                <p>Nenhum registro até o momento...</p>
            </div>
        </div>
        <div class="row no-gutters mt-3">
            <div class="mat-elevation table-content">
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="10%" class="ml-2">
                        <mat-label>Campo Filtro</mat-label>
                        <mat-select (selectionChange)="this.fieldFilter()" [(value)]="typeFieldFilterSelected"
                            [(ngModel)]="typeFieldFilterSelected">
                            <mat-option *ngFor="let type of typeFieldSelect" [value]="type.value">
                                {{ type.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="40%" class="ml-2">
                        <mat-label>Filtrar</mat-label>
                        <input matInput autocomplete="off" (keyup)="this.applyFilter()" [(ngModel)]="filter"
                            style="text-transform: uppercase;" #input>
                    </mat-form-field>
                </div>
                <table mat-table [dataSource]="parametersTypes" matSort class="mat-elevation-z8">

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição do Parâmetro</th>
                        <td mat-cell *matCellDef="let element" style="text-transform: uppercase;">{{ element.name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="operationType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo da Operação</th>
                        <td mat-cell *matCellDef="let element">{{ getOperationTypeDescription(element.operation_type) }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="fieldName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome do Campo Válido</th>
                        <td mat-cell *matCellDef="let element" style="text-transform: uppercase;">{{
                            element.field_name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="ruleModelContains">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Regra de Modelo de Veiculo</th>
                        <td mat-cell *matCellDef="let element" style="text-transform: uppercase;">{{
                            element.rule_model_contains}}</td>
                    </ng-container>

                    <ng-container matColumnDef="update">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Editar" matTooltip="Editar">
                                <a (click)="this.router.navigate(['tipo-parametro/edit/' + element.uuid])"
                                    class="btn btn-link">
                                    <img height="20" src="assets/img/edit.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <button (click)="handleDelete(element)" class="btn btn-link" matTooltip="Apagar">
                                <img height="20" src="assets/img/trash-cadastro.svg" alt="" />
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 20, 40]" [pageSize]="parametersModelPage.page.size"
                    (page)="onChangePage($event)" [length]="parametersModelPage.page.totalElements"
                    showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>